
import { App } from 'vue'

import LanguageChanger from './LanguageChanger.vue'

const install = (app: App<Element>, prefix = 'Ui'): void => {
  app
    .component('LanguageChanger', LanguageChanger)

}

export default {
  install,
}
